import React from 'react';
import { connect } from 'react-redux';
import style from './SpeedText.css';
const SpeedText = ({ speed }) => React.createElement("span", { className: style.speedValue },
    speed,
    "x");
function mapStateToProps(state) {
    return { speed: state.clock.speed };
}
export default connect(mapStateToProps)(SpeedText);
